import { WHATSEASE, STATS_UPDATED_AT } from "@/lib/siteStats";
import { formatCount, showCount } from "@/lib/statsFormat";

// Stats for the VilvaChat / WhatsApp page. Values come from the single
// public/stats.json snapshot — see lib/siteStats.ts.
//
// Source: the whatsease DB. "Delivered" counts only status 'read' or
// 'delivered' — roughly 45% of all message rows are 'failed', so a raw total
// would overstate reality by a wide margin. See StatsController::site().

export const WHATSEASE_UPDATED_AT = STATS_UPDATED_AT;

const show = showCount;

// Display string + the unrounded figure behind it, so <StatNumber> can reveal
// the exact number on hover.
export const WHATSEASE_STATS = [
  { value: show(WHATSEASE.messages_delivered), exact: WHATSEASE.messages_delivered, target: WHATSEASE.messages_delivered, format: formatCount, label: "Messages Delivered" },
  { value: show(WHATSEASE.messages_read), exact: WHATSEASE.messages_read, target: WHATSEASE.messages_read, format: formatCount, label: "Messages Read" },
  { value: show(WHATSEASE.contacts_managed), exact: WHATSEASE.contacts_managed, target: WHATSEASE.contacts_managed, format: formatCount, label: "Contacts Managed" },
  { value: show(WHATSEASE.campaigns_run), exact: WHATSEASE.campaigns_run, target: WHATSEASE.campaigns_run, format: formatCount, label: "Campaigns Run" },
];
